module.exports = ".email-text {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: block;\r\n    max-width: 200px;\r\n  }\r\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/components/competitions/edit-competition/edit-competition.component.css
// module id = ./src/app/components/competitions/edit-competition/edit-competition.component.css
// module chunks = main